import { render } from "./OwnTroops.vue?vue&type=template&id=70a4afbe"
import script from "./OwnTroops.vue?vue&type=script&lang=js"
export * from "./OwnTroops.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/villageOverview/troops/OwnTroops.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70a4afbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70a4afbe', __exports__)) {
    api.reload('70a4afbe', __exports__)
  }
  
  module.hot.accept("./OwnTroops.vue?vue&type=template&id=70a4afbe", () => {
    api.rerender('70a4afbe', render)
  })

}


export default __exports__